var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: [_vm.bemBlock, "image-container"] }, [
    _c(
      "a",
      {
        class: _vm.bemElement("link"),
        attrs: { draggable: "false", href: _vm.url },
        on: {
          click: function($event) {
            $event.preventDefault()
            return (function() {})($event)
          }
        }
      },
      [
        _vm.shouldShowCarousel
          ? _c("BaseCarousel", {
              attrs: {
                bem: "base-product-tile-carousel",
                "are-controls-shown": _vm.areCarouselControlsShown,
                items: _vm.productImageSets,
                "context-product-id": _vm.productId,
                "swiper-options": { allowTouchMove: !_vm.isSliderContext }
              },
              on: {
                "carousel-click": function($event) {
                  return _vm.$emit("click")
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(slotProps) {
                      return [
                        _c("BaseImage", {
                          class: slotProps.classname,
                          attrs: {
                            "image-classes": _vm.bemElement("image"),
                            image: _vm.getDefaultImageFromProductImageSet(
                              slotProps.item
                            ),
                            loading:
                              _vm.forceMainImageToLoad && slotProps.index === 0
                                ? "eager"
                                : slotProps.loading,
                            placeholder: _vm.getPlaceholderImageFromProductImageSet(
                              slotProps.item
                            ),
                            sizes: _vm.sizes,
                            "use-title": false,
                            srcset: _vm.getSrcsetFromProductImageSet(
                              slotProps.item
                            )
                          },
                          on: {
                            load: function($event) {
                              return _vm.handleImageLoad(slotProps.index)
                            }
                          }
                        })
                      ]
                    }
                  }
                ],
                null,
                false,
                2767131994
              )
            })
          : _c("BaseImage", {
              class: _vm.bemElement("pic"),
              attrs: {
                "image-classes": _vm.bemElement("image"),
                image: _vm.getDefaultImageFromProductImageSet(_vm.mainImage),
                loading: _vm.forceMainImageToLoad ? "eager" : null,
                placeholder: _vm.getPlaceholderImageFromProductImageSet(
                  _vm.mainImage
                ),
                sizes: _vm.sizes,
                srcset: _vm.getSrcsetFromProductImageSet(_vm.mainImage),
                "use-title": false
              },
              on: {
                "image-click": function($event) {
                  return _vm.$emit("click", $event)
                },
                load: function($event) {
                  return _vm.handleImageLoad(0)
                }
              }
            })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }